export default "__VITE_ASSET__Ce49pha0__"